import { TLoginViews } from '@features/loginPage/typescript';
import { TImage } from '@components/typescript';
import { BASE_PATH } from '@config/index';

export const LOGIN_PAGE_TYPES: TLoginViews = {
  general: {
    name: 'general',
    goBackUrl: '/',
    goBackText: 'goBack',
    headerTitle: 'login',
    redirectPath: '/',
    guestHeader: 'continueAsGuest',
    guestButton: 'continueAsGuest',
  },
  checkout: {
    name: 'checkout',
    goBackUrl: '/cart',
    goBackText: 'checkout.backToCart',
    headerTitle: 'finalizeOrder',
    redirectPath: '/checkout/order',
    guestHeader: 'buyAsGuest',
    guestButton: 'buyAsGuest',
  },
};

export const LOGIN_PAGE_IMG: TImage = {
  desktop: `${BASE_PATH}/img/login/porady-desktop.jpg`,
  tablet: `${BASE_PATH}/img/login/porady-tablet.jpg`,
  mobile: `${BASE_PATH}/img/login/porady-mobi.jpg`,
};

export const SESSION_STORAGE_REDIRECT_KEY = 'redirectScope';

export const REDIRECT_SCOPE = {
  checkout: '/checkout/order',
};

export default LOGIN_PAGE_TYPES;
